"use client";

import { useEffect, useState } from "react";

import { useRouter } from "next/navigation";

import { LoginForm, type LoginUser } from "@pulseprep/shared-ui";
import { toast, useAdminLogin } from "@pulseprep/shared-ui/hooks";

import { adminAuthStore } from "@/app/_libs/stores/admin-auth.store";

export function LoginPageClient() {
  const router = useRouter();
  const { adminLogin, isLoading } = useAdminLogin();
  const [isRedirecting, setIsRedirecting] = useState(false);

  useEffect(() => {
    adminAuthStore.clear();
  }, []);

  const handleSuccess = (user: LoginUser) => {
    setIsRedirecting(true);
    adminAuthStore.setRoles(user.roles);
    const profile = user as LoginUser & {
      id: string;
      email: string;
      firstName?: string | null;
      lastName?: string | null;
    };
    adminAuthStore.setUser({
      id: profile.id,
      email: profile.email,
      firstName: profile.firstName ?? null,
      lastName: profile.lastName ?? null,
    });
    toast.success("Welcome back! It's good to see you again.");
    const roleHome = adminAuthStore.isSuperAdmin() ? "/admin/dashboard" : "/dashboard";
    router.push(roleHome);
  };

  return (
    <LoginForm
      loginFn={adminLogin}
      isLoading={isLoading || isRedirecting}
      onSuccess={handleSuccess}
      headingTitle="Welcome!"
      headingSubtitle="Sign in to continue with your account"
      emailPlaceholder="admin@pulseprep.com"
      submitLabel="Log in"
      showDisabledModal
    />
  );
}
